import { getSts, getSts2 } from '@/api/api'
const OSS = require('ali-oss');

// export const ossOrigin = 'http://meiyukc.oss-cn-shenzhen.aliyuncs.com/'
// export const ossType = 'meiyu'

export const ossOrigin = 'https://mashu1.oss-cn-hangzhou.aliyuncs.com/'
export const ossType = 'kbam'

let store = null

// let sts = JSON.parse(localStorage.getItem("mykc-sts"))
let sts = JSON.parse(localStorage.getItem("kbam-sts"))
export const ossPut = async (url, file) => {
    if (!sts || new Date() > new Date(sts.Expiration)) {
        // 没有获取信息或者过期，重新请求
        let stsRes = await getSts()
        console.log('stsRes', stsRes)
        sts = stsRes.data.data
        // localStorage.setItem('mykc-sts', JSON.stringify(stsRes.data.data))
        localStorage.setItem('kbam-sts', JSON.stringify(stsRes.data.data))
        store = new OSS({
            // region: 'oss-cn-shenzhen',
            region: 'oss-cn-hangzhou',
            accessKeyId: stsRes.data.data.AccessKeyId,
            accessKeySecret: stsRes.data.data.AccessKeySecret,
            // bucket: 'meiyukc',
            bucket: 'mashu1',
            stsToken: sts.SecurityToken
        })
        return new Promise((resolve) => {
            store.put(url, file).then(res => resolve(res))
        })
    } else {
        console.log('sts', sts)
        store = new OSS({
            // region: 'oss-cn-shenzhen',
            region: 'oss-cn-hangzhou',
            accessKeyId: sts.AccessKeyId,
            accessKeySecret: sts.AccessKeySecret,
            // bucket: 'meiyukc',
            bucket: 'mashu1',
            stsToken: sts.SecurityToken
        })
        console.log('store', JSON.stringify({
            region: 'oss-cn-hangzhou',
            accessKeyId: sts.AccessKeyId,
            accessKeySecret: sts.AccessKeySecret,
            bucket: 'mashu1',
            stsToken: sts.SecurityToken
        }))
        return new Promise((resolve) => {
            store.put(url, file).then(res => resolve(res))
        })
    }
}

export const ossPut2 = async (url, file) => {
    if (!sts || new Date() > new Date(sts.Expiration)) {
        // 没有获取信息或者过期，重新请求
        let stsRes = await getSts2()
        sts = stsRes.data.data
        // localStorage.setItem('mykc-sts', JSON.stringify(stsRes.data.data))
        localStorage.setItem('kbam-sts', JSON.stringify(stsRes.data.data))
        store = new OSS({
            // region: 'oss-cn-shenzhen',
            region: 'oss-cn-hangzhou',
            accessKeyId: stsRes.data.data.AccessKeyId,
            accessKeySecret: stsRes.data.data.AccessKeySecret,
            // bucket: 'meiyukc',
            bucket: 'mashu1',
            stsToken: sts.SecurityToken
        })
        return new Promise((resolve) => {
            store.put(url, file).then(res => resolve(res))
        })
    } else {
        store = new OSS({
            // region: 'oss-cn-shenzhen',
            region: 'oss-cn-hangzhou',
            accessKeyId: sts.AccessKeyId,
            accessKeySecret: sts.AccessKeySecret,
            // bucket: 'meiyukc',
            bucket: 'mashu1',
            stsToken: sts.SecurityToken
        })
        return new Promise((resolve) => {
            store.put(url, file).then(res => resolve(res))
        })
    }
}